/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_No_Text_ErrorInputs */

const en_read_along_ai_no_text_error = /** @type {(inputs: Read_Along_Ai_No_Text_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document has no available text. Restore archived documents before generating insights.`)
};

const es_read_along_ai_no_text_error = /** @type {(inputs: Read_Along_Ai_No_Text_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este documento no tiene texto disponible. Restaura los documentos archivados antes de generar información.`)
};

/**
* | output |
* | --- |
* | "This document has no available text. Restore archived documents before generating insights." |
*
* @param {Read_Along_Ai_No_Text_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_no_text_error = /** @type {((inputs?: Read_Along_Ai_No_Text_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_No_Text_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_no_text_error(inputs)
	return en_read_along_ai_no_text_error(inputs)
});